import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { ERRORS, messages, TABLE_QUERY_KEYS } from 'app/config/constants';
import { queryClient } from 'app/app';
import { PaginationState } from 'app/shared/pagination/pagination.model';
import success = toast.success;
import error = toast.error;
import { CaseConstructionLegalityDocumentAddFormModel, CaseConstructionLegalityModel } from '../model/case-construction-legality.model';
import {
  deleteCaseConstructionLegalityDocument,
  fetchCaseConstructionLegality,
  fetchCaseConstructionLegalityDocument,
  fetchCaseConstructionLegalityDocuments, fetchSavedCaseConstructionLegalityDocument,
  saveCaseConstructionLegality,
  saveCaseConstructionLegalityDocument
} from './case-construction-legality.service';

export const saveCaseConstructionLegalityQuery = (idCase: string) => {
  return useMutation({
    mutationFn: (values: CaseConstructionLegalityModel) => {
      return saveCaseConstructionLegality(idCase, values);
    },
    onSuccess: () => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: ['case-construction-legality'] });
    },
    onError: (err: any) => {
      if (Object.values(ERRORS).includes(err.response?.data?.detail)) {
        showToast(toast.error, err.response?.data?.detail);
      } else {
        showToast(toast.error, ERRORS.GENERIC_ERROR);
      }
    },
  });
};

export const fetchCaseConstructionLegalityQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['case-construction-legality'],
    queryFn: () => fetchCaseConstructionLegality(idCase),
  });
};

export const updateCaseConstructionLegalityDocumentQuery = (idCase: string, resetForm: Function, successCallback: Function) => {
  return useMutation({
    mutationFn: (data: CaseConstructionLegalityDocumentAddFormModel) => saveCaseConstructionLegalityDocument(idCase, data),
    onSuccess: (data: CaseConstructionLegalityDocumentAddFormModel) => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.CASE_CONSTRUCTION_LEGALITY_DOCUMENTS_TABLE] });
      resetForm({ values: data });
      successCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const deleteCaseConstructionLegalityDocumentQuery = (idCase: string, closeModalCallback: Function) => {
  return useMutation({
    mutationFn: (webId: string) => deleteCaseConstructionLegalityDocument(idCase, webId),
    onSuccess: () => {
      showToast(success, messages.DATA_DELETED);
      queryClient.invalidateQueries({ queryKey: [TABLE_QUERY_KEYS.CASE_CONSTRUCTION_LEGALITY_DOCUMENTS_TABLE] });
      closeModalCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};

export const fetchCaseConstructionLegalityDocumentsQuery = (pagination: PaginationState, idCase: string) => {
  return useQuery({
    queryKey: [TABLE_QUERY_KEYS.CASE_CONSTRUCTION_LEGALITY_DOCUMENTS_TABLE, { ...pagination }, idCase],
    queryFn: ({ signal }) => fetchCaseConstructionLegalityDocuments({ signal, pagination, idCase }),
  });
};

export const fetchCaseConstructionLegalityDocumentQuery = (idCase: string, webId: string) => {
  return useQuery({
    queryKey: ['case-construction-legality-document', { webId: webId }],
    queryFn: () => fetchCaseConstructionLegalityDocument({ idCase, webId }),
    enabled: !!webId,
  });
};


export const fetchSavedCaseConstructionLegalityDocumentQuery = (idCase: string, idCaseConstructionLegalityDocumentMap: string) => {
  return useQuery({
    queryKey: ['case-construction-legality-document', { idCaseConstructionLegalityDocumentMap: idCaseConstructionLegalityDocumentMap }],
    queryFn: () => fetchSavedCaseConstructionLegalityDocument({ idCase, idCaseConstructionLegalityDocumentMap }),
    enabled: !!idCaseConstructionLegalityDocumentMap,
  });
};

